import m from "mithril";

import {
	defineWidget, Icon, CardieWidget, NoticeWidget, Empty, ButtonNew
} from "@nebularstreams/libmui"

import {TitleBarWidget} from "./misc/TitleBarWidget";
import MAINSTATE from "../State";
import SERVICES from "../../config/Services";
import {authLoginOrganization, clearPersistedAuth} from "../Api";

//////////////////////////////////////////////////////////////

const STR = {
	WELCOME: "Welcome !",
	ORGANIZATION: "Organization:",
	NO_SERVICES: "No enabled studio services for this organization",
	TITLE: "nanoStream Studio",
	LOG_OUT: "log out"
};

//////////////////////////////////////////////////////////////
// UI WIDGETS

const
	// widget: Main Screen
	LauncherScreen = defineWidget(
		({state}) => [
			m(TitleBarWidget, {rootTitle: "Studio", version: MAINSTATE.version || "unknown"}),
			m(".flexcol.h-100.ohidden.grows.scrolly.outercontent",
				m(".flexcol.grows.noshrink.innercontent",
					state.loadingContent
						? [m(Empty, {icon: "sync.fa-spin", size: 2, class: "pad-2"})]
						: [
							m(CardieWidget,
								{
									class: "status",
									nofold: true,
									element: "div"
								},
								// first card
								m(".streamname.grows.unitheightsmall", `${STR.ORGANIZATION} ${MAINSTATE.organization}`),
								m(ButtonNew, {
									class: "redbutton unitheightsmall",
									icon: "power-off",
									text: STR.LOG_OUT,
									onClick: () => {
										clearPersistedAuth();
										m.route.set("/");
									}
								})
							),

							// body
							m(".flexrow.ohidden.maincontainer",
								[
									m(".flexrow.wrap.grows.ohidden.part-left.scrolly.fadein", [
										MAINSTATE.error
											? [
												m(NoticeWidget, {
													class: "rednotice marg-2",
													icon: "exclamation-triangle",
													text: MAINSTATE.error,
													onClick: () => {
														delete MAINSTATE.error;
														m.redraw();
													}
												})
											]
											: state.allowedServices?.length
												? state.allowedServices
													.map(
														({id, icon, title, description}) => m(".launchcard.flexcol",
															{
																onclick: () => m.route.set(`/${MAINSTATE.organization}/${id}`)
															},
															[
																m(Icon, {icon, size: 2}),
																m("h2", title),
																m("h4", description)
															]))
												: m(Empty, {
													size: 2,
													icon: "sad-tear",
													message: STR.NO_SERVICES
												})
									])
								]
							)
						])
			)
		],

		async ({attrs, state}) => {

			if (!MAINSTATE.availableServices || !MAINSTATE.version) {
				state.loadingContent = true;
				await authLoginOrganization(attrs.key);
				state.loadingContent = false;
			}

			if (MAINSTATE.availableServices) {
				state.allowedServices = SERVICES
					.filter(({id}) => MAINSTATE.availableServices.includes(id))
				m.redraw();
			} else {
				m.route.set("/");
			}
			document.title = STR.TITLE;
		}
	);

export default LauncherScreen;
